<button
    [class]="'button ' + fromSize(size) + ' ' + fromRole(role)"
    type="submit"
    [class._success]="validate"
    [class._disabled]="disabled"
    [disabled]="disabled"
    (click)="doAction($event)">
    <div (click)="doAction($event)">
        <ng-content></ng-content>
    </div>
</button>
